export const AVATAR_API = "https://ui-avatars.com/api";
export const API = "https://orca-app-oxt3w.ondigitalocean.app/api";
export const API_Photo = "https://orca-app-oxt3w.ondigitalocean.app";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
